import 'regenerator-runtime/runtime';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import { searchScheduledEmail } from './api';
import * as ActivityActionType from './constants';
import * as NotifyActionType from '../constants/notification-action-type';

export function* searchScheduledEmailAsync(action) {
  const result = yield call(searchScheduledEmail, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: ActivityActionType.SEARCH_SCHEDULED_EMAIL_SUCCESS,
      data: {
        data: result.data,
        params: action.params
      }
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export default function* WatchActivities() {
  yield all([
    takeLatest(
      ActivityActionType.SEARCH_SCHEDULED_EMAIL_ASYNC,
      searchScheduledEmailAsync
    )
  ]);
}



// WEBPACK FOOTER //
// ./src/Activities/saga.js